import {MenuItem} from '../../models';

/** holds items for rewards dropdown used in navbar */
export const REWARDS_LIST: MenuItem[] = [{title: 'Rewards', link: '/rewards'},
  {title: 'Custom Rewards', link: '/cash-register'}];
